import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

export const AdministratorVenueEventAlertIssues = () => {
    const dispatch = useDispatch();

    const [venueEventAlertIssues, setVenueEventAlertIssues] = useState([]);
    const [venueEventAlertIssueCount, setVenueEventAlertIssueCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areVenueEventAlertIssuesLoading, setAreVenueEventAlertIssuesLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {  
        const content = props.dataItem[props.field];
        
        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const ViewUrlCell = (props) => {  
        const url = props.dataItem[props.field];     

        return (
            <td className={"text-nowrap"}>
                {url ? <Link to={{ pathname: url }} target={"_blank"} rel={"noopener noreferrer"}>View Website</Link> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getVenueEventAlertIssues = (newPageNumber) => {
        setAreVenueEventAlertIssuesLoading(true);

        const dataItem = {
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/venueeventalertissues`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreVenueEventAlertIssuesLoading(false);                
                setItemsPerPage(result.venueEventAlertIssuesPerPage);
                setSkipCount(result.venueEventAlertIssuesPerPage * (result.pageNumber - 1));
                setVenueEventAlertIssueCount(result.totalVenueEventAlertIssueCount);                
                setVenueEventAlertIssues(result.venueEventAlertIssues);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreVenueEventAlertIssuesLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getVenueEventAlertIssues(newPageNumber);
    };

    useEffect(() => {
        document.title = "Event Alert Issues";

        getVenueEventAlertIssues();
    }, []);

    return (
        <div>
            {areVenueEventAlertIssuesLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={venueEventAlertIssues}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={venueEventAlertIssueCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Created"} />
                        <Column field="eventName" title={"Event"} />
                        <Column field="venueName" title={"Venue"} />
                        <Column field="eventDate" title={"Date"} />
                        <Column field="venueEventStatusTypeName" title={"Status"} />
                        <Column field="sectionName" title={"Section"} />
                        <Column field="venueEventAlertTypeName" title={"Type"} />
                        <Column field="isResolved" title={"Resolved"} />
                        <Column field="notes" title={"Notes"} cell={ViewDialogCell} />
                        <Column field="ticketingUrl" title={"Website"} cell={ViewUrlCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}